import { Project } from "@nova/protobuf"
import {
    demoIdValidators,
    genericCreateLayerValidator,
    genericUpdateLayerValidator,
    UnionToTuple,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

export const createPanoramaFlightValidator = genericCreateLayerValidator

export const updatePanoramaFlightValidator = {
    ...genericUpdateLayerValidator,
    demoId: {
        validators: demoIdValidators,
    },
}

export const getDefaultPanoramaFlightCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    images: [],
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreatePanoramaFlightArgs = UnionToTuple<keyof typeof createPanoramaFlightValidator>
export type UpdatePanoramaFlightArgs = UnionToTuple<keyof typeof updatePanoramaFlightValidator>
